import React from 'react'
import { useSelector } from 'react-redux'
import PageResult from '../../../features/search/components/page-result'
import { Featured } from '../../event/components'

const DetailEvent = () => {
  const defaultFeatureds = useSelector(state => state.organization.featured_events)

  return (
    <PageResult
      customHeader={<></>}
      customNav={<Featured embed={true} defaultItems={defaultFeatureds}/>}
    />
  )
}

export { DetailEvent }
